<template>
    <div class="item-footer">
        <!-- <dv-border-box-1 class="item-footer">        -->
            <div>全概率公式：</div>  
       <div>{{content}}</div>
       <button @click="calc_PB">=</button>
       <!-- <div class="pb_value">{{value}}</div> -->
       <input :class="[move_left?'text_set_right':'text_move_left']" type="text" :value="value" onfocus="this.select()" readonly='true' style="background-color:inherit"> 
       <!-- </dv-border-box-1> -->
       <div class="btn_calc_a" @click="calc_PB" title="全概率计算" :style="{'width':(ele_num * 15 + 20)+'%' ,'max-width':'500px'}">
                全概率计算
        </div>
    </div>
    
</template>

<script>
export default {
   name:'BayItemFooter',
    data(){
        return {
            move_left:false,
        }
    },
    props:{
        content:String,
        value:String,
        
    },
    methods:{
        calc_PB(){
            this.$emit('calc_PB');
        }
    },
    computed:{
        ele_num(){
            return this.content.split('+').length;
        },
        c_value(){
            return this.value;
        }
    },
    watch:{
        ele_num(){
            console.log('number of ele changed:'+ this.ele_num);
        },
        c_value(){
            this.move_left = true;
             setTimeout(()=>this.move_left=false,100);
        }
    }
}
</script>

<style lang="stylus" scoped>

@import '~css/mixins.styl';
@import '~css/var.styl';
.item-footer
    position:relative;
    center()
    height:$total_height
    //border-top:1px solid rgba(0,0,0,.1)
    //background-color:$main_footer_color;
    padding-left:100px;
    font-family:auto;
    font-size:larger;
    font-weight:bold;
    & button
        clear_default_style();
        margin:0 10px;
        padding:2px 5px;
        background-color:inherit;

        &:hover
            background-color:lighten( $main_footer_color,40%)

    & input 
        clear_default_style()
        width:70px;
        border-bottom:1px solid rgba(0,0,0,.4)
        font-size:16px;
        margin-top:8px;
        box-sizing:border-box;

.pb_value
    background-color:white;
    padding:0px 10px;
    border-bottom:1px solid rgba(0,0,0,.1)



.btn_calc_a
    position:absolute;
    //transform:translateY(-50%);
    clear_default_style()
    center();
    height:60px;
    padding:5px 10px;
    font-size:20px;
    border-radius:5px;
    //background-color:lighten(blue,20%);
    color:white;
    left:50%;
    transform:translate(calc(-50% + 50px),-50%);
    width:80%;
    height:55%;
    top:0%;
    background:url('~pic/down_blue_l.png') center no-repeat;
    background-size:100% 100%;
    cursor pointer
     

    &:hover
        //& buttonbackground-color:lighten(blue,40%);
        //border:1px solid green;
        color:red;

.text_move_left
    padding-left:0%;
    transition:padding 1s;

.text_set_right
    padding-left:65px;


</style>
